
export const COST_PER_DEVICE_PER_DAY = 25;
export const PEOPLE_PER_SCREEN = 4;
export const HOURS_PER_DAY = 12;
export const PLAYS_PER_HOUR = 48;
export const MIN_CLICKS_PER_GROUP = 1;
export const MAX_CLICKS_PER_GROUP = 3;
export const AVG_CLICKS_PER_GROUP = (MIN_CLICKS_PER_GROUP + MAX_CLICKS_PER_GROUP) / 2;
export const VAT_RATE = 0.15;
export const BASE_DISCOUNT_RATE = 0.05;
export const MAX_DISCOUNT_RATE = 0.30;
